import { z } from "zod";
import {
  AccommodationDtoSchema,
  accommodationFromDto,
  AccommodationSchema,
  accommodationToDto,
} from "./accommodation";
import {
  Fulfillment,
  FulfillmentDtoSchema,
  fulfillmentFromDto,
  FulfillmentSchema,
} from "./fulfillment";
import { apiListSchema } from "./list";
import {
  HotelRoomDtoSchema,
  hotelRoomFromDto,
  HotelRoomSchema,
} from "./hotel-room";

//? DTO
export const AccommodationWithFulfillmentsDtoSchema =
  AccommodationDtoSchema.extend({
    Balance: z.number().nullish(),
    IsPayed: z.boolean().nullish(),
    HotelRoom: HotelRoomDtoSchema.nullish(),
    FulfillmentAccommodations: z
      .array(
        z.object({
          FulfillmentId: z.number(),
          AccommodationId: z.number(),
          Fulfillment: FulfillmentDtoSchema.nullish(),
        }),
      )
      .nullish(),
  });
export type AccommodationWithFulfillmentsDto = z.infer<
  typeof AccommodationWithFulfillmentsDtoSchema
>;
export const AccommodationWithFulfillmentsDtoListSchema = apiListSchema(
  AccommodationWithFulfillmentsDtoSchema,
);

//? Model

export const AccommodationSchemaWithFulfillments = AccommodationSchema.extend({
  balance: z.number().nullish(),
  isPayed: z.boolean().nullish(),
  hotelRoom: HotelRoomSchema.nullish(),
  fulfillments: z.array(FulfillmentSchema).nullish(),
  reservationClients: z.undefined(),
});
export type AccommodationWithFulfillments = z.infer<
  typeof AccommodationSchemaWithFulfillments
>;

//? Mappers
export function accommodationWithFulfillmentsFromDto(
  dto: AccommodationWithFulfillmentsDto,
): AccommodationWithFulfillments {
  return {
    ...accommodationFromDto(dto),
    reservationClients: undefined,
    balance: dto.Balance,
    isPayed: dto.IsPayed,
    hotelRoom: dto.HotelRoom ? hotelRoomFromDto(dto.HotelRoom) : undefined,
    fulfillments:
      (dto.FulfillmentAccommodations?.map((fa) =>
        fa.Fulfillment ? fulfillmentFromDto(fa.Fulfillment) : undefined,
      ).filter(Boolean) as Fulfillment[]) ?? [],
  };
}

export function accommodationWithFulfillmentsToDto(
  model: AccommodationWithFulfillments,
): AccommodationWithFulfillmentsDto {
  return {
    ...accommodationToDto({ ...model, reservationClients: [] }),
    AccommodationReservationClients: undefined,
    Balance: undefined as unknown as number,
    IsPayed: undefined as unknown as boolean,
    FulfillmentAccommodations: model.fulfillments?.map((f) => {
      return {
        FulfillmentId: Number.parseInt(f.id),
        AccommodationId: Number.parseInt(model.id),
        Fulfillment: undefined,
      };
    }),
  };
}
